<template>
  <div>
    <v-container max-width="2100">
      <v-card class="mx-auto my-5" max-width="2100">
        <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
          Informe de Nutrición Mensual
        </v-system-bar>
      </v-card>
      <v-card class="mx-auto my-5 px-3 elevation-1" max-width="2100">
        <v-row>
          <v-col>
            <table style="width: 100%;border-spacing: 8px;">
              <tr>
                <td style="width: 10%" colspan="2">Centro Contratado</td>
                <td style="width: calc(100% - 10%)" colspan="2" class="bordeado">
                  {{ centroContratado }}
                </td>
              </tr>
              <tr>
                <td colspan="2">Nutricionistas a cargo</td>
                <td class="bordeado">{{ nutricionista }}</td>
              </tr>

            </table>
            <table style="width: 100%;padding: 0 0.4rem;border-spacing: 4px;">
              <tr>
                <td style="width: 10%">Mes</td>
                <td style="width: calc(50% - 10%)" colspan="2" class="bordeado">
                  {{ mesReporte }}
                </td>
                <td style="width: 10%;padding-left: 2rem;">Fecha de Reporte</td>
                <td class="bordeado" style="width: calc(50% - 10%)">{{ fechaReporte }}</td>
              </tr>
            </table>
            <!-- <v-row>
              <v-col cols="1" sm="1" md="1" style="padding:.4rem">
                <span>Centro</span>
              </v-col>
              <v-col cols="11" sm="11" md="11" style="padding:.4rem">
                <v-text-field
                  label="Centro Contratado"
                  placeholder="Centro Contratado"
                  outlined
                  dense
                  readonly
                  v-model="centroContratado"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" sm="1" md="1" style="padding:.4rem">
                <span>Nutricionistas</span>
              </v-col>
              <v-col cols="11" sm="11" md="11" style="padding:.4rem">
                <v-text-field
                  label="Nutricionistas a cargo"
                  placeholder="Nutricionistas a cargo"
                  outlined
                  dense
                  readonly
                  v-model="centroContratado"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" sm="1" md="1">
                <span>Mes</span>
              </v-col>
              <v-col cols="5" sm="5" md="5">
                <v-text-field
                  label="Mes"
                  placeholder="Mes"
                  outlined
                  dense
                  readonly
                  v-model="centroContratado"
                ></v-text-field>
              </v-col>
              <v-col cols="1" sm="1" md="1">
                <span>Fecha</span>
              </v-col>
              <v-col cols="5" sm="5" md="5">
                <v-text-field
                  label="Fecha de Reporte"
                  placeholder="Fecha de Reporte"
                  outlined
                  dense
                  readonly
                  v-model="centroContratado"
                ></v-text-field>
              </v-col>
            </v-row>-->
          </v-col>
        </v-row>

        <v-row style="padding: 0 0.7rem;margin-top: 0;">
          <v-col cols="6" sm="1" md="1" style="display: flex; align-items: center;padding: 0 0.5rem;margin-top: 0;">
            <h4>Filtro:</h4>
          </v-col>
          <v-col cols="6" sm="5" md="5">
            <input type="date" v-model="date" id="myDate" class="mx-3" />
            <v-btn color="#1973a5" dark class="mb-2" @click="filtro">
              Filtrar
            </v-btn>
          </v-col>
          <v-col cols="6" sm="6" md="6" class="d-flex justify-content-end">
            <v-btn color="success" dark class="mb-2" @click="downloadExcel">
              Descargar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mx-auto my-5" max-width="2100">
        <div style="max-height: 70vh; overflow-y: scroll">
          <v-data-table :headers="headers" :items="indexedData" class="elevation-1 py-5" :search="searchDistrito"
            :sort-by.sync="sortBy" :loading="isLoading" loading-text="Cargando... Por favor espere">
          </v-data-table>
        </div>
      </v-card>
    </v-container>
  </div>
</template>
<style>
.bg-primary-table {
  /* background: rgb(27 160 255 / 12%); */
  font-weight: 460;
}

table {
  font-size: .9rem;
}

.bordeado {
  border: 1px solid #0000004a;
  border-radius: 0.3rem;
  padding: 0.3rem;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 2.1rem;
}

.justify-content-end {
  justify-content: end;
}

.container {
  max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
/* import * as XLSX from 'xlsx'; */
/* import XLSX from 'xlsx'; */
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
  data() {
    return {
      valor1: 15,
      valor2: 10,
      ver: false,
      dataReporte: [],
      search: "",
      centroContratado: "",
      nutricionista: "",
      dataEnvio: {
        fecha: null,
        usuario: null,
        descripCas: null
      },
      date: new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      searchDistrito: "",
      searchClinica: "",
      isLoading: true,
      sortBy: [{ key: "cupos_disponible", order: "asc" }],
      headers: [
        { text: "N°", value: "index" },
        { text: "Nombre", value: "paciente" },
        {
          text: "Día/ Turno",
          align: "start",
          value: "turno",
        },
        { text: "Fecha de Ingreso", value: "fechaIngreso" },
        { text: "Fec. Evaluación Nut.", value: "fechaEvaluacion" },
        { text: "Edad", value: "fecha_nac" },
        { text: "Peso", value: "peso", align: "center" },
        { text: "Talla", value: "talla", align: "center" },
        { text: "ICM", value: "imc", align: "center" },
        { text: "CMB", value: "porcentajeCMB", align: "center" },
        { text: "EPT", value: "porcentajeEPT", align: "center" },
        { text: "ALB", value: "albSerica", align: "center" },
        { text: "MIS", value: "MIS", align: "center" },
        { text: "ING.CAL.", value: "ingestaCalorica", align: "center" },
        { text: "ING.PROT.", value: "ingestaProteica", align: "center" },
        {
          text: "Diagnostico Nutricional ",
          value: "diagNutricional",
          align: "center",
        },
        {
          text: "Intervención Nutricional ",
          value: "interveNutricional",
          align: "center",
        },
        { text: "Observaciones ", value: "obsNutricion", align: "center" },
      ],
      fechaReporte: "",
      mesReporte: ""
    };
  },
  methods: {
    filtro() {
      const partesFecha = this.date.split('-');
      const año1 = partesFecha[0];
      const mes1 = partesFecha[1];
      const dia1 = partesFecha[2];
      this.fechaReporte = `${dia1}-${mes1}-${año1}`;
      this.dataEnvio.fecha = this.formatearFecha(this.date);
      this.dataInit();
      this.loadFecha(this.dataEnvio.fecha);
    },
    dataInit() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/repInformeNutricion/", this.dataEnvio, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              console.log("exito", res);
              this.isLoading = false;
              this.dataReporte = res.data;
              this.centroContratado = res.data[0].descripCas;
              console.log(res.data[0].descripCas);
              this.nutricionista = res.data[0].nombre;
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    downloadExcel() {
      const XLSXStyle = require("xlsx-js-style");

      // STEP 1: Create a new workbook
      const wb = XLSXStyle.utils.book_new();

      // STEP 2: Create data rows and styles
      const headers = [
        { text: "INFORME MENSUAL DE NUTRICIÓN", cell: "B2", style: true },
        { text: "", cell: "C2", style: false },
        { text: "", cell: "D2", style: false },
        { text: "", cell: "E2", style: false },
        { text: "", cell: "F2", style: false },
        { text: "", cell: "G2", style: false },
        { text: "", cell: "H2", style: false },
        { text: "", cell: "I2", style: false },
        { text: "", cell: "J2", style: false },
        { text: "", cell: "K2", style: false },
        { text: "", cell: "L2", style: false },
        { text: "", cell: "M2", style: false },
        { text: "", cell: "N2", style: false },
        { text: "", cell: "L2", style: false },
        { text: "", cell: "O2", style: false },
        { text: "", cell: "P2", style: false },
        { text: "", cell: "Q2", style: false },
        { text: "", cell: "R2", style: false },
        { text: "", cell: "S2", style: false },
        { text: "CENTRO CONTRATADO", cell: "B4", style: false },
        { text: "", cell: "C4", style: false },
        { text: this.centroContratado, cell: "D4", style: false },
        { text: "", cell: "E4", style: false },
        { text: "", cell: "F4", style: false },
        { text: "", cell: "G4", style: false },
        { text: "", cell: "H4", style: false },
        { text: "", cell: "I4", style: false },
        { text: "", cell: "J4", style: false },
        { text: "", cell: "K4", style: false },
        { text: "", cell: "L4", style: false },
        { text: "", cell: "M4", style: false },
        { text: "", cell: "N4", style: false },
        { text: "", cell: "L4", style: false },
        { text: "", cell: "O4", style: false },
        { text: "", cell: "P4", style: false },
        { text: "", cell: "Q4", style: false },
        { text: "", cell: "R4", style: false },
        { text: "", cell: "S4", style: false },
        { text: "NUTRICIONISTAS A CARGO", cell: "B5", style: false },
        { text: "", cell: "C5", style: false },
        { text: this.nutricionista, cell: "D5", style: false },
        { text: "", cell: "E5", style: false },
        { text: "", cell: "F5", style: false },
        { text: "", cell: "G5", style: false },
        { text: "", cell: "H5", style: false },
        { text: "", cell: "I5", style: false },
        { text: "", cell: "J5", style: false },
        { text: "", cell: "K5", style: false },
        { text: "", cell: "L5", style: false },
        { text: "", cell: "M5", style: false },
        { text: "", cell: "N5", style: false },
        { text: "", cell: "L5", style: false },
        { text: "", cell: "O5", style: false },
        { text: "", cell: "P5", style: false },
        { text: "", cell: "Q5", style: false },
        { text: "", cell: "R5", style: false },
        { text: "", cell: "S5", style: false },
        { text: "MES", cell: "B6", style: false },
        { text: this.mesReporte, cell: "C6", style: false },
        { text: "FECHA DE REPORTE", cell: "R6", style: false },
        { text: this.fechaReporte, cell: "S6", style: false },
        {
          text: "Nº pacientes casos problemas ( con diagnostico de desnutriciòn en el mes)",
          cell: "B10",
          style: false,
        },
        { text: "", cell: "C10", style: false },
        { text: "", cell: "D10", style: false },
        { text: "", cell: "E10", style: false },
        { text: "", cell: "F10", style: false },
        { text: "Nº pacientes con DPE en el mes", cell: "G10", style: false },
        { text: "", cell: "H10", style: false },
        { text: "", cell: "I10", style: false },
        { text: "", cell: "J10", style: false },
        { text: "", cell: "K10", style: false },
        { text: "N° Pacientes Nuevos", cell: "L10", style: false },
        { text: "", cell: "M10", style: false },
        { text: "", cell: "N10", style: false },
        { text: "", cell: "O10", style: false },
        { text: "", cell: "P10", style: false },
        { text: "N° Pacientes Continuadores", cell: "Q10", style: false },
        { text: "", cell: "R10", style: false },
        { text: "", cell: "S10", style: false },
        { text: "Nº", cell: "B11", style: true },
        { text: "", cell: "B12", style: false },
        { text: "APELLIDOS Y NOMBRES", cell: "C11", style: true },
        { text: "", cell: "C12", style: false },
        { text: "DIA/TURNO", cell: "D11", style: true },
        { text: "", cell: "D12", style: false },
        { text: "FECHA DE INGRESO", cell: "E11", style: true },
        { text: "", cell: "E12", style: false },
        { text: "FECHA DE EVALUAC .NUT", cell: "F11", style: true },
        { text: "", cell: "F12", style: false },
        { text: "EDAD (años)", cell: "G11", style: true },
        { text: "", cell: "G12", style: false },
        { text: "PESO (kg)", cell: "H11", style: true },
        { text: "", cell: "H12", style: false },
        { text: "TALLA (m)", cell: "I11", style: true },
        { text: "", cell: "I12", style: false },
        { text: "IMC (kg/m)", cell: "J11", style: true },
        { text: "", cell: "J12", style: false },
        { text: "% C.M.B", cell: "K11", style: true },
        { text: "", cell: "K12", style: false },
        { text: "%EPT", cell: "L11", style: true },
        { text: "", cell: "L12", style: false },
        { text: "ALB()", cell: "M11", style: true },
        { text: "", cell: "M12", style: false },
        { text: "MIS", cell: "N11", style: true },
        { text: "", cell: "N12", style: false },
        { text: "EVALUAC. DIETETICA", cell: "O11", style: true },
        { text: "ING. CAL (CAL/KG)", cell: "O12", style: true },
        { text: "ING. PROT. (PROT/KG)", cell: "P12", style: true },
        { text: "DIAGNOSTICO NUTRICIONAL", cell: "Q11", style: true },
        { text: "", cell: "Q12", style: false },
        { text: "INTERVENCIÒN NUTRICIONAL", cell: "R11", style: true },
        { text: "", cell: "R12", style: false },
        { text: "OBSERVACIONES", cell: "S11", style: true },
        { text: "", cell: "S12", style: false },
      ];
      // STEP 3: Create worksheet with rows; Add worksheet to workbook
      const ws = XLSXStyle.utils.aoa_to_sheet([]);
      for (let i = 0; i < headers.length; i++) {
        const element = headers[i];
        XLSXStyle.utils.sheet_add_aoa(ws, [[element.text]], {
          origin: element.cell,
        });
        ws[element.cell].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
            bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
            left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
            right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
          },
          alignment: { wrapText: true },
        };
        if (element.style) {
          ws[element.cell].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
          };
        }
      }

      const wscols = [
        { wch: 3 },
        { wch: 4 },
        { wch: 27 },
        { wch: 10 },
        { wch: 18 },
        { wch: 18 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 8 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
      ]; // Ancho de la celda A1 y B1 respectivamente
      ws["!cols"] = wscols;
      // Agrandar la altura de la fila para que se ajuste al texto con salto de línea
      ws["!rows"] = [, , , , , , , , , , { hpt: 40, hpx: 30 }]; // Ajusta la altura de la fila a 40 puntos

      // STEP 5: Merge cells from B1 to J1
      const mergeCells = [
        { s: { r: 1, c: 1 }, e: { r: 1, c: 18 } },
        { s: { r: 3, c: 3 }, e: { r: 3, c: 18 } },
        { s: { r: 4, c: 3 }, e: { r: 4, c: 18 } }, // Combinar B1 hasta J1
        { s: { r: 3, c: 1 }, e: { r: 3, c: 2 } },
        { s: { r: 4, c: 1 }, e: { r: 4, c: 2 } },
        { s: { r: 9, c: 1 }, e: { r: 9, c: 5 } },
        { s: { r: 9, c: 6 }, e: { r: 9, c: 9 } },
        { s: { r: 9, c: 11 }, e: { r: 9, c: 15 } },
        { s: { r: 9, c: 16 }, e: { r: 9, c: 18 } },
        { s: { r: 10, c: 14 }, e: { r: 10, c: 15 } },
        { s: { r: 10, c: 1 }, e: { r: 11, c: 1 } },
        { s: { r: 10, c: 2 }, e: { r: 11, c: 2 } },
        { s: { r: 10, c: 3 }, e: { r: 11, c: 3 } },
        { s: { r: 10, c: 4 }, e: { r: 11, c: 4 } },
        { s: { r: 10, c: 5 }, e: { r: 11, c: 5 } },
        { s: { r: 10, c: 6 }, e: { r: 11, c: 6 } },
        { s: { r: 10, c: 7 }, e: { r: 11, c: 7 } },
        { s: { r: 10, c: 8 }, e: { r: 11, c: 8 } },
        { s: { r: 10, c: 9 }, e: { r: 11, c: 9 } },
        { s: { r: 10, c: 10 }, e: { r: 11, c: 10 } },
        { s: { r: 10, c: 11 }, e: { r: 11, c: 11 } },
        { s: { r: 10, c: 12 }, e: { r: 11, c: 12 } },
        { s: { r: 10, c: 13 }, e: { r: 11, c: 13 } },
        { s: { r: 10, c: 16 }, e: { r: 11, c: 16 } },
        { s: { r: 10, c: 17 }, e: { r: 11, c: 17 } },
        { s: { r: 10, c: 18 }, e: { r: 11, c: 18 } },
        // Combinar B2 hasta P2 (por ejemplo)
        // Agregar más combinaciones de celdas según sea necesario
      ];
      /* ws['!merges'] = mergeCells; */
      // Aplicar bordes a cada celda dentro del rango combinado
      for (let R = mergeCells[0].s.r; R <= mergeCells[0].e.r; ++R) {
        for (let C = mergeCells[0].s.c; C <= mergeCells[0].e.c; ++C) {
          const cellAddress = { r: R, c: C };
          const cellRef = XLSXStyle.utils.encode_cell(cellAddress);
          if (!ws[cellRef]) continue;
          ws[cellRef].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
          };
        }
      }

      //Formatos especificos
      ws["B2"].s = {
        alignment: {
          horizontal: "center", // Centrar horizontalmente
          vertical: "center", // Centrar verticalmente
        },
        fill: { fgColor: { rgb: "7A7A7A" } },
        font: { color: { rgb: "FFFFFF" }, bold: true },
        border: {
          top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
          bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
          left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
          right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
        },
      };
      const initialRow = 13;
      const dataArray = Object.values(this.dataReporte).map((item, index) => [
        index + 1,
        item.paciente,
        item.turno,
        item.fechaIngreso,
        item.fechaEvaluacion,
        item.fecha_nac,
        item.peso,
        item.talla,
        item.imc,
        item.porcentajeCMB,
        item.porcentajeEPT,
        item.albSerica,
        item.MIS,
        item.ingestaCalorica,
        item.ingestaProteica,
        item.diagNutricional,
        item.interveNutricional,
        item.obsNutricion,
      ]);

      // Iterar sobre los datos y obtener el número de fila para cada uno
      const rowNumbers = Array.from(
        { length: dataArray.length },
        (_, index) => initialRow + index
      );

      // Iterar sobre los datos y agregarlos a la hoja de cálculo
      dataArray.forEach((row, index) => {
        const rowNumber = rowNumbers[index];
        XLSXStyle.utils.sheet_add_aoa(ws, [row], { origin: `B${rowNumber}` });
      });

      // Aplicar bordes a las celdas
      rowNumbers.forEach((rowNumber) => {
        for (let col = 2; col <= dataArray[0].length + 1; col++) {
          if (!ws[`${this.numberToColumn(col)}${rowNumber}`]) {
            XLSXStyle.utils.sheet_add_aoa(ws, [["-"]], {
              origin: `${this.numberToColumn(col)}${rowNumber}`,
            });
          }
          ws[`${this.numberToColumn(col)}${rowNumber}`].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
          };
        }
      });
      //Se agrega el footer
      const initCells = rowNumbers.length + 17;

      const footerCuadro1 = [
        { text: "PERFIL NUTRICIONAL", style: false, col: "C" },
        { text: "DIAGNOSTICO PROFESIONAL", style: true, col: "C" },
        { text: "DIAGNOSTICO PROFESIONAL", style: true, col: "C" },
        { text: "OBESIDAD", style: true, col: "C" },
        { text: "SOBREPESO", style: true, col: "C" },
        { text: "NORMAL", style: true, col: "C" },
        { text: "DESNUTRICIÓN LEVE", style: true, col: "C" },
        { text: "DESNUTRICIÓN MODERADA", style: true, col: "C" },
        { text: "DESNUTRICIÓN SEVERA", style: true, col: "C" },
        { text: "TOTAL", style: true, col: "C" },
      ];
      let indice = 0;

      for (let row = initCells; row < initCells + 10; row++) {
        XLSXStyle.utils.sheet_add_aoa(ws, [[footerCuadro1[indice].text]], {
          origin: `${footerCuadro1[indice].col}${row}`,
        });
        if (footerCuadro1[indice].style) {
          ws[`${footerCuadro1[indice].col}${row}`].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
            font: { bold: true },
          };
        } else {
          ws[`${footerCuadro1[indice].col}${row}`].s = {
            font: { bold: true },
          };
        }
        indice++;
      }
      const footerCuadro2 = [
        { text: "", style: false, col: "D" },
        { text: "ENE. PAC", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
        { text: "", style: true, col: "D" },
      ];
      let indice2 = 0;

      for (let row = initCells; row < initCells + 10; row++) {
        XLSXStyle.utils.sheet_add_aoa(ws, [[footerCuadro2[indice2].text]], {
          origin: `${footerCuadro2[indice2].col}${row}`,
        });
        if (footerCuadro2[indice2].style) {
          ws[`${footerCuadro2[indice2].col}${row}`].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
            font: { bold: true },
          };
        } else {
          ws[`${footerCuadro2[indice2].col}${row}`].s = {
            font: { bold: true },
          };
        }
        indice2++;
      }

      const footerCuadro3 = [
        { text: "", style: false, col: "E" },
        { text: "%", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
        { text: "", style: true, col: "E" },
      ];
      let indice3 = 0;

      for (let row = initCells; row < initCells + 10; row++) {
        XLSXStyle.utils.sheet_add_aoa(ws, [[footerCuadro3[indice3].text]], {
          origin: `${footerCuadro3[indice3].col}${row}`,
        });
        if (footerCuadro3[indice3].style) {
          console.log("hola");
          ws[`${footerCuadro3[indice3].col}${row}`].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
            font: { bold: true },
          };
        } else {
          ws[`${footerCuadro3[indice3].col}${row}`].s = {
            font: { bold: true },
          };
        }
        indice3++;
      }
      /* Cuadro Observaciones */
      const footerObservaciones = [{ text: "COMENTARIO:", col: "O" }];
      for (let index = 0; index < footerObservaciones.length; index++) {
        for (let row = initCells + 1; row < initCells + 6; row++) {
          XLSXStyle.utils.sheet_add_aoa(
            ws,
            [[footerObservaciones[index].text]],
            { origin: `${footerObservaciones[index].col}${row}` }
          );
          ws[`${footerObservaciones[index].col}${row}`].s = {
            underline: true,
            font: { bold: true },
          };
        }
      }
      /* Cuadro combinado de COMENTARIOS */

      for (let row = initCells + 2; row < initCells + 8; row++) {
        for (let index = 15; index < 20; index++) {
          XLSXStyle.utils.sheet_add_aoa(ws, [[""]], {
            origin: `${this.numberToColumn(index)}${row}`,
          });
          ws[`${this.numberToColumn(index)}${row}`].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
              bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
              left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
              right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
            },
          };
        }
      }
      let coordenadas = {
        s: { r: initCells + 1, c: 14 },
        e: { r: initCells + 6, c: 18 },
      };
      mergeCells.push(coordenadas);

      //Cuadro firmas
      const firmas = [
        { text: "__________________________", col: "P" },
        { text: "Firma y sello Nutricionista", col: "P" },
        { text: "C.N.P N°:................", col: "P" },
      ];

      let index = 0;
      for (let row = initCells + 9; row < initCells + 12; row++) {
        XLSXStyle.utils.sheet_add_aoa(ws, [[firmas[index].text]], {
          origin: `${firmas[index].col}${row}`,
        });
        ws[`${firmas[index].col}${row}`].s = {
          font: { bold: true },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
        };
        index++;
      }

      let coordenadasFirmas1 = {
        s: { r: initCells + 8, c: 15 },
        e: { r: initCells + 8, c: 16 },
      };
      let coordenadasFirmas2 = {
        s: { r: initCells + 9, c: 15 },
        e: { r: initCells + 9, c: 16 },
      };
      let coordenadasFirmas3 = {
        s: { r: initCells + 10, c: 15 },
        e: { r: initCells + 10, c: 16 },
      };
      mergeCells.push(coordenadasFirmas1);
      mergeCells.push(coordenadasFirmas2);
      mergeCells.push(coordenadasFirmas3);
      ws["!merges"] = mergeCells;

      XLSXStyle.utils.book_append_sheet(wb, ws, "readme demo");

      // STEP 4: Write Excel file to browser
      const excelBuffer = XLSXStyle.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Reporte_Nutricion.xlsx";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    numberToColumn(num) {
      let columnName = "";
      while (num > 0) {
        let remainder = (num - 1) % 26;
        columnName = String.fromCharCode(65 + remainder) + columnName;
        num = Math.floor((num - 1) / 26);
      }
      return columnName;
    },
    formatearFecha(fecha) {
      // Dividir la fecha en partes: año, mes y día
      const partes = fecha.split("-");
      // Crear una nueva fecha con el formato "mm-dd-yyyy"
      const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
      // Obtener el mes, día y año de la nueva fecha
      const mes = nuevaFecha.getMonth() + 1;
      const dia = nuevaFecha.getDate();
      const año = nuevaFecha.getFullYear();
      // Formatear la fecha en el formato deseado
      return `${mes.toString().padStart(2, "0")}-${dia
        .toString()
        .padStart(2, "0")}-${año}`;
    },
    loadFecha(fecha) {
      const partesFecha = fecha.split('-');
      const fechaActual = new Date(partesFecha[2], partesFecha[0] - 1, partesFecha[1]);
      const nombreMeses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      this.mesReporte = nombreMeses[fechaActual.getMonth()];
      console.log("mes de Reporte", this.mesReporte);
    },
    fechaHoy() {
      /* const ahora = new Date();
      // Ajustar la zona horaria a Perú (GMT-5)
      const zonaHorariaPeru = ahora.getTimezoneOffset() + 300; // 5 horas * 60 minutos
      const fechaPeru = new Date(ahora.getTime() + zonaHorariaPeru * 60000); // Convertir minutos a milisegundos
      this.date = fechaPeru.toLocaleDateString('es-PE'); */
      const ahora = new Date();
      const dia = ahora.getDate();
      const mes = ahora.getMonth() + 1;
      const año = ahora.getFullYear();
      // Formatear la fecha en el formato "yyyy-MM-dd"
      this.date = `${año}-${mes < 10 ? '0' + mes : mes}-${dia < 10 ? '0' + dia : dia}`;
      const partesFecha = this.date.split('-');
      const año1 = partesFecha[0];
      const mes1 = partesFecha[1];
      const dia1 = partesFecha[2];
      // Formatear la fecha en el formato "mm-dd-yyyy"  
      this.loadFecha(`${mes1}-${dia1}-${año1}`);
      this.fechaReporte = `${dia1}-${mes1}-${año1}`;

    }
  },
  mounted() { },
  computed: {
    filteredData() {
      if (!this.searchDistrito && !this.searchClinica) {
        return this.dataReporte;
      }

      let filtered = this.dataReporte;

      if (this.searchDistrito) {
        filtered = filtered.filter((item) =>
          item.distrito_clinica
            .toLowerCase()
            .includes(this.searchDistrito.toLowerCase())
        );
      }

      if (this.searchClinica) {
        filtered = filtered.filter((item) =>
          item.clinica.toLowerCase().includes(this.searchClinica.toLowerCase())
        );
      }

      return filtered;
    },

    headersWithIndex() {
      return [
        { text: "#", value: "index" }, // Encabezado para el índice
        ...this.headers, // Encabezados existentes
      ];
    },
    // Utiliza la matriz de datos con índices
    indexedData() {
      return this.filteredData.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  created() {
    this.centroContratado = sessionStorage.getItem("descripCas");
    this.dataEnvio.descripCas = sessionStorage.getItem("descripCas");
    this.nutricionista = sessionStorage.getItem("nombre");
    this.fechaHoy();
    console.log(sessionStorage.getItem("usuario"));
    this.dataEnvio.usuario = sessionStorage.getItem("usuario");
    console.log("Hola");
    this.dataInit();
  },
  components: {},
};
</script>